import React from 'react';
import _ from 'lodash'

import { AboutBlock } from '../Blocks'

import audit1 from '../../assets/images/audit/consultant2.png'

const AuditFour2 = ({ lang }) => {
  const isEn = lang === 'en';

  const AboutBlocks = [
    {
      rootProps: { className: 'tile row' },
      image: { rootProps: { className: 'col-6 col-12-medium image' }, image: audit1 },
      textGroup: {
        rootProps: { className: 'text-group col-6 col-12-medium' },
        title: {
          type: 'h2',
          text:
            isEn ? 'Book your free hour!' : 'Marque a sua hora grátis!',
        },
        description: {
          text:
            isEn ? "EN" : "O seu site WordPress é a coluna vertebral da sua empresa! Juntos, podemos melhorar a sua presença online e converter mais visitantes em clientes.",
        },
        cta: {
            rootProps: {
              className: 'button audit-btn audit-anchor-link talktous-form',
              to: isEn ? '#' : '#',
            },
            text: isEn ? "Let's Speak" : 'Fale connosco',
        },
      },
    },
  ]

  return (
    <section id="audit-four-intro" className="bg-white bg-gray">
      <div className="content container">
        <div className="row">
          {_.map(AboutBlocks, (block, i) => (
            <React.Fragment key={`about-block-${i}`}>
              <AboutBlock rev={i % 2} {...block} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  )
};

export default AuditFour2;
